/**
 * Routes Configuration
 *
 * Defines all application routes using React Router v6.
 */

import { createBrowserRouter } from 'react-router-dom';
import { AuthGuard } from '../components/auth/AuthGuard';

// Lazy load pages for better performance
import { lazy } from 'react';

const LandingPage = lazy(() => import('../components/pages/LandingPage'));
const AboutPage = lazy(() => import('../components/pages/AboutPage'));
const AppPage = lazy(() => import('../components/pages/AppPage'));
const NotFoundPage = lazy(() => import('../components/pages/NotFoundPage'));
const AccountPage = lazy(() => import('../components/pages/AccountPage'));
const PrivacyPage = lazy(() => import('../components/pages/PrivacyPage'));
// Temporary: Nota Input test page
const NotaInputTestPage = lazy(() => import('../components/pages/NotaInputTestPage'));

/**
 * Application router configuration
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/app',
    element: (
      <AuthGuard>
        <AppPage />
      </AuthGuard>
    ),
  },
  {
    path: '/account',
    element: (
      <AuthGuard>
        <AccountPage />
      </AuthGuard>
    ),
  },
  {
    path: '/nota-input',
    element: <NotaInputTestPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
